import type {TitleBarDetailsModal} from 'src/action-creators/modal';

import * as React from 'react';

import {TitleBarModal} from 'src/components/modals/base-modal';

import ConfirmIcon from 'src/images/icons/confirm-icon.svg?noAttrs';

import css from 'common';


const GenericSuccessModal = (props: TitleBarDetailsModal) => (
  <TitleBarModal
    {...props}
    titleIcon={
      // @ts-expect-error - TS2322 - Type '{ style: { fill: string; }; }' is not assignable to type 'IntrinsicAttributes'.
      props.titleIcon ?? <ConfirmIcon style={{fill: css.colorWhite}} />
    }
  />
);

export default GenericSuccessModal;
